import "./ConfimationModal.scss";
import { Button } from "../Button/Button";
import { Modal } from "../Modal/Modal";

function ModalBody({ modalText, modalDescpText }) {
  return (
    <>
      <div className="view-endagement-delete-modal-body">{modalText}</div>
      <div className="view-endagement-delete-modal-body-descr">
        {modalDescpText}
      </div>
    </>
  );
}

function ModalFooter({
  handleCancelClick,
  onConfirm,
  confirmButtonText,
  cancelButtonText,
  confirmVariant,
  confirmClassName,
  isConfirming,
}) {
  return (
    <div className="view-endagement-delete-modal-footer">
      <Button
        variant="secondary"
        onClick={handleCancelClick}
        disabled={isConfirming}
      >
        {cancelButtonText}
      </Button>
      <Button
        onClick={onConfirm}
        variant={confirmVariant}
        className={confirmClassName}
        disabled={isConfirming}
      >
        {confirmButtonText}
      </Button>
    </div>
  );
}

export function ConfirmationModal({
  isModalVisible,
  onClose,
  onConfirm,
  modalHeaderText,
  modalBodyText,
  modalDescriptionText,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  confirmVariant = "primary",
  confirmClassName = "",
  isConfirming = false,
  className,
  size,
}) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={modalHeaderText}
      className={className}
      size={size}
      body={
        <ModalBody
          modalText={modalBodyText}
          modalDescpText={modalDescriptionText}
        />
      }
      footer={
        <ModalFooter
          handleCancelClick={onClose}
          onConfirm={onConfirm}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
          confirmVariant={confirmVariant}
          confirmClassName={confirmClassName}
          isConfirming={isConfirming}
        />
      }
    />
  );
}
